<template>
  <el-dialog
    :visible.sync="dialogVisible"
    class="job-requirement-dialog"
    :close-on-click-modal="false"
    append-to-body
    width="80vw"
  >
    <div slot="title" class="dialog-title">
      岗位相关要求选择<span style="color:#F56C6C">（以下标签选择填写，跟岗位有关的要求建议尽量多填）</span>
    </div>

    <div class="job-requirement-content">
      <div class="left-box">
        <div class="requirement-row">
          <p class="requirement-title">核心要求汇总</p>
          <div class="flex mb10">
            <el-input
              v-model="project.核心要求汇总"
              class="mr10"
              type="textarea"
              :rows="2"
              placeholder="和客户电话沟通时可以快速填写全部核心要求，项目创建后请把核心要求填成下方一条一条的格式"
            ></el-input>
          </div>
        </div>
        <div class="requirement-row">
          <p class="requirement-title">
            核心要求：<span style="color:#F56C6C">（可以在下面补充我们没有或无法标签化的要求）</span>
          </p>
          <div v-for="(item, index) in project.核心要求" :key="`corerequirement${index}`" class="flex mb10">
            <span class="mr10" style="align-self:center">{{ index + 1 }}:</span>
            <el-input
              v-model="project.核心要求[index]"
              class="mr10"
              type="textarea"
              :rows="2"
              placeholder="核心要求请写成一条一条的。  例：本科学历，985/211"
            ></el-input>
            <i class="ft-danger el-icon-delete" style="align-self:center" @click="removeQuestion(index)" />
          </div>
          <div class="flex justify-center">
            <a @click="addQuestion"> <i class="el-icon-circle-plus" />增加一条要求 </a>
          </div>
        </div>
        <div class="requirement-row">
          <p class="requirement-title">通用要求：<span class="quick-btn" @click="getTagFromJd">解析JD</span></p>
          <div class="requirement-content-box">
            <div class="requirement-content-item">
              <span class="requirement-label">性别</span>
              <el-select v-model="project['性别']" filterable size="mini">
                <el-option
                  v-for="val in ['男', '女', '不限']"
                  :key="`radishPicGender${val}`"
                  :value="val"
                  :label="val"
                />
              </el-select>
            </div>
            <div class="requirement-content-item">
              <span class="requirement-label">婚育</span>
              <el-select v-model="project['婚育']" filterable size="mini">
                <el-option
                  v-for="val in ['未婚', '已婚未育', '已婚已育', '其他']"
                  :key="`marry${val}`"
                  :value="val"
                  :label="val"
                />
              </el-select>
            </div>
            <div class="requirement-content-item">
              <span class="requirement-label">倾向年龄</span>
              <div class="flex align-center">
                <el-input v-model="project['年龄要求'][0]" style="width:75px" size="mini">
                  <template slot="append"
                    >岁</template
                  >
                </el-input>
                --
                <el-input v-model="project['年龄要求'][1]" style="width:75px" size="mini">
                  <template slot="append"
                    >岁</template
                  >
                </el-input>
              </div>
            </div>
            <div class="requirement-content-item">
              <span class="requirement-label">地域</span>
              <el-select v-model="project['地域']" multiple filterable size="mini">
                <el-option v-for="val in locations" :key="`location${val}`" :value="val" :label="val" />
              </el-select>
            </div>
          </div>
        </div>
        <div class="requirement-row">
          <p class="requirement-title">学历背景：</p>
          <div class="requirement-content-box">
            <div class="requirement-content-item" style="width:100%">
              <span class="requirement-label">学历要求</span>
              <el-select v-model="project['学历要求']" class="mr10" filterable size="mini">
                <el-option v-for="val in 学历要求" :key="`eduRequirement${val}`" :value="val" :label="val" />
              </el-select>
              <span>及以上</span>
            </div>
            <div class="requirement-content-item" style="width:100%">
              <span class="requirement-label">倾向学历</span>
              <el-checkbox-group v-model="project.倾向学历" style="text-align: left;">
                <el-checkbox v-for="i in 倾向学历" :key="i" :label="i"></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="requirement-row">
          <p class="requirement-title">岗位相关：</p>
          <div class="requirement-content-box">
            <div
              v-for="item in 岗位相关"
              :key="`岗位相关${item.label}`"
              :class="[item.type === 'checkbox' ? 'requirement-content-item-checkbox' : '', 'requirement-content-item']"
            >
              <span class="requirement-label">{{ item.label }}</span>
              <!-- TODO:职能模块是否变成那种职能模块库的 -->
              <el-select
                v-if="item.label === '职能模块'"
                v-model="project['职能模块']"
                :multiple="item.mul"
                filterable
                size="mini"
              >
                <el-option
                  v-for="val in item.options"
                  :key="`${item.label}${typeof val === 'object' ? val.label : val}`"
                  :value="typeof val === 'object' ? val.value : val"
                  :label="typeof val === 'object' ? val.label : val"
                />
              </el-select>
              <div v-else-if="item.label === '工作年限'" class="flex align-center">
                <el-input v-model="project['工作年限'][0]" style="width:75px" size="mini">
                  <template slot="append"
                    >年</template
                  >
                </el-input>
                --
                <el-input v-model="project['工作年限'][1]" style="width:75px" size="mini">
                  <template slot="append"
                    >年</template
                  >
                </el-input>
              </div>
              <el-checkbox-group
                v-else-if="item.type === 'checkbox'"
                v-model="project['标签']"
                style="text-align: left;align-items: center;display: flex;flex-wrap: wrap;"
              >
                <el-checkbox v-for="i in item.options" :key="i" :label="i"></el-checkbox>
              </el-checkbox-group>
              <el-select v-else v-model="project[item.value]" :multiple="item.mul" filterable size="mini">
                <el-option
                  v-for="val in item.options"
                  :key="`${item.label}${typeof val === 'object' ? val.label : val}`"
                  :value="typeof val === 'object' ? val.value : val"
                  :label="typeof val === 'object' ? val.label : val"
                />
              </el-select>
            </div>
          </div>
        </div>
        <div class="requirement-row">
          <p class="requirement-title">专业能力：</p>
          <div class="requirement-content-box">
            <div class="requirement-content-item" style="width:100%">
              <span class="requirement-label">语言能力</span>
              <el-checkbox-group
                v-model="project['标签']"
                style="text-align: left;align-items: center;display: flex;flex-wrap: wrap;"
              >
                <el-checkbox v-for="i in tags['语言能力']" :key="i" :label="i"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="requirement-content-item" style="width:100%">
              <span class="requirement-label">专业能力</span>
              <el-checkbox-group
                v-model="project['标签']"
                style="text-align: left;align-items: center;display: flex;flex-wrap: wrap;"
              >
                <el-checkbox v-for="i in tags['专业因素']" :key="i" :label="i"></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="requirement-row">
          <p class="requirement-title">软性能力：</p>
          <div class="requirement-content-box">
            <div class="requirement-content-item" style="width:100%">
              <span class="requirement-label">领导能力</span>
              <el-checkbox-group
                v-model="project['标签']"
                style="text-align: left;align-items: center;display: flex;flex-wrap: wrap;"
              >
                <el-checkbox v-for="i in tags['领导']" :key="i" :label="i"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="requirement-content-item" style="width:100%">
              <span class="requirement-label">个人风格</span>
              <el-checkbox-group
                v-model="project['标签']"
                style="text-align: left;align-items: center;display: flex;flex-wrap: wrap;"
              >
                <el-checkbox v-for="i in tags['个人风格']" :key="i" :label="i"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="requirement-content-item" style="width:100%">
              <span class="requirement-label">心态/性格</span>
              <el-checkbox-group
                v-model="project['标签']"
                style="text-align: left;align-items: center;display: flex;flex-wrap: wrap;"
              >
                <el-checkbox v-for="i in tags['心态、个性']" :key="i" :label="i"></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          (hasRadishImage && radishImageFields.length > 0) || (hasRadishCateImage && radishImageCateFields.length > 0)
        "
        class="right-box"
      >
        <el-tooltip effect="dark" placement="top">
          <div slot="content">人才画像分析：<br />根据该客户公司人才数据生成，辅助您去填写岗位要求</div>
          <p class="radish-pic-analyze-title mb20">人才画像分析</p>
        </el-tooltip>
        <div v-if="hasRadishImage && radishImageFields.length > 0" class="mb10">
          <el-button size="small">客户公司所有人员画像</el-button>
          <div class="radish-content">
            <div v-for="item in radishImageFields" :key="`radishImageFields${item}`" class="radish-content-item">
              <span class="flex-none mr10" style="word-break:keep-all">{{ item }}:</span>
              <span class="flex-auto">{{ radishImageTemplate(radishImage, item) }}</span>
            </div>
          </div>
        </div>
        <div v-if="hasRadishCateImage && radishImageCateFields.length > 0">
          <el-button size="small">客户公司现有同职能人员画像 </el-button>
          <div class="radish-content">
            <div v-for="item in radishImageCateFields" :key="`radishImageFields${item}`" class="radish-content-item">
              <span class="flex-none mr10" style="word-break:keep-all">{{ item }}:</span>
              <span class="flex-auto">{{ radishImageTemplate(radishImageCate, item) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer" style="display:flex;justify-content: center;">
      <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
    </span>

    <!-- component -->
    <TagClassifyDialog ref="TagClassifyDialog" @confirm="tagClassifyConfirm"></TagClassifyDialog>
  </el-dialog>
</template>
<script>
import { locations, professionalRank, manageRank, tags, 业绩, professionalLevel } from '../../constant/type'
import { defaultProject } from '../../constant/defaultData'
import * as fixedvariant from '../../../../company/statistics/variant/fixedvariant'
import TagClassifyDialog from './TagClassifyDialog'

export default {
  components: { TagClassifyDialog },
  data() {
    return {
      dialogVisible: false,
      project: window._.cloneDeep(defaultProject),
      hasRadishImage: false,
      hasRadishCateImage: false,
      radishImage: {},
      radishImageCate: {},
      defaultRadishImageFields: [
        '年龄',
        '稳定性',
        '学历要求',
        '平台',
        '学历标签',
        '性别',
        '工作年限',
        '地域',
        '来源公司',
        '来源行业',
        '业绩',
        '专业能力',
        '语言能力',
        '领导能力',
        '心态/性格',
        '个人风格',
      ],
      fields: [
        '性别',
        '婚育',
        '年龄要求',
        '地域',
        '学历要求',
        '倾向学历',
        '职能模块',
        '细分职能',
        '擅长方向',
        '投资风格',
        '目标行业',
        '平台',
        '业绩',
        '工作年限',
        '职级',
        '管理职级',
        '专业职级',
        '标签',
        '核心要求',
        '核心要求汇总',
      ],
      倾向学历: fixedvariant.公司用人偏好.学历.filter(v => !['博士及以上', '硕士', '本科', '常青藤'].includes(v)),
      学历要求: ['博士后', '博士', '硕士', '本科', '大专', '中专'],
      岗位相关: [
        { label: '职能模块', value: '职能模块', type: 'select', mul: false, options: [] },
        { label: '细分职能', value: '细分职能', type: 'select', mul: true, options: [] },
        { label: '擅长方向', value: '擅长方向', type: 'select', mul: true, options: [] },
        // TODO:投资风格单选还是多选
        {
          label: '投资风格',
          value: '投资风格',
          type: 'select',
          mul: false,
          options: ['GARP型', '价值型', '成长型', '极致成长型', '综合型'],
        },
        {
          label: '职业资格',
          value: '职业资格',
          type: 'checkbox',
          mul: true,
          options: [
            '保代',
            '准保',
            '保代A类',
            '保代B类',
            '保代C类',
            '基金从业资格',
            '证券从业资格',
            'CFA',
            'CPA',
            'FRM',
            '律师执业资格',
            '法律从业资格',
            'REITs基金经理从业资格',
            '期货从业资格',
            '银行从业资格',
            'CIA（审计师）',
            'ACCA（国际注册会计师）',
            'CMA（美国注册管理会计师）',
            'CISA（信息系统审计师）',
            'CTA（税务师）',
            'SOA（北美保险精算师）',
            'CAA（保险精算师）',
          ],
        },
        { label: '目标行业', value: '目标行业', type: 'select', mul: true, options: [] },
        { label: '平台', value: '平台', type: 'select', mul: true, options: ['A', 'B', 'C'] },
        { label: '业绩', value: '业绩', type: 'select', mul: true, options: 业绩 },
        {
          label: '工作年限',
          value: '工作年限',
        },
        { label: '职级', value: '职级', mul: true, options: professionalLevel },
        { label: '管理职级', value: '管理职级', type: 'select', mul: true, options: manageRank },
        { label: '专业职级', value: '专业职级', type: 'select', mul: true, options: professionalRank },
        {
          label: '稳定性',
          value: '稳定性',
          type: 'select',
          mul: false,
          options: ['工作很稳定', '工作较稳定', '稳定性一般', '工作平均服务年限不足两年', '工作转换频繁'],
        },
      ],
      singleTag: ['性别', '婚育', '学历要求', '职能模块', '投资风格', '稳定性'],
      tagsLabelTranslate: {
        领导能力: '领导',
        个人风格: '个人风格',
        '心态、个性': '心态/性格',
        语言能力: '语言能力',
        专业能力: '专业因素',
      },
    }
  },
  computed: {
    locations() {
      return locations
    },
    tags() {
      const obj = {}
      tags.forEach(tag => {
        obj[tag.label] = tag.children
      })
      return obj
    },
    accounts() {
      return window.app.accounts || []
    },
    radishImageFields() {
      const { defaultRadishImageFields, radishImage, radishImageTemplate } = this
      return defaultRadishImageFields.filter(v => radishImageTemplate(radishImage, v))
    },
    radishImageCateFields() {
      const { defaultRadishImageFields, radishImageCate, radishImageTemplate } = this
      return defaultRadishImageFields.filter(v => radishImageTemplate(radishImageCate, v))
    },
  },
  async mounted() {
    if (!app.categories) await app.getCats()
    this.categories = window._.cloneDeep(app.categories)

    const zhineng = this.岗位相关.find(v => v.label === '职能模块')
    zhineng.options = this.categories.map(v => v.名称)
    const hangye = this.岗位相关.find(v => v.label === '目标行业')
    hangye.options = app.industries || []

    this.$watch(
      function() {
        // 第一个函数就是处理你要监听的属性，只要将其return出去就行
        return this.project.职能模块
      },
      function(newValue, oldValue) {
        const cate = this.categories.find(v => v.名称 === newValue)
        const xifen = this.岗位相关.find(v => v.label === '细分职能')
        xifen.options = (cate && cate.二级职能) || []
        const shanchang = this.岗位相关.find(v => v.label === '擅长方向')
        shanchang.options = (cate && cate.擅长方向) || []
      },
    )
  },
  methods: {
    open(project, company) {
      const copyProject = window._.cloneDeep(project)
      const { fields } = this
      const obj = { 标签分类: copyProject.标签分类 }
      fields.forEach(v => {
        obj[v] = copyProject[v] || (typeof defaultProject[v] === 'object' ? window._.cloneDeep(defaultProject[v]) : '')
        if (v === '核心要求' && obj[v].length === 0) obj[v].push('', '')
      })
      this.project = obj
      this.copyProject = copyProject
      this.hasRadishImage = false
      this.hasRadishCateImage = false
      if (company && company._id) this.getCompanyRadishImage(company)
      if (company && company._id && copyProject.职能模块) this.getCompanyRadishImageCate(company, copyProject.职能模块)
      // TODO:测试用
      // this.getCompanyRadishImage({ _id: 'SkEyvqeM7X' })
      // this.getCompanyRadishImageCate({ _id: 'SkEyvqeM7X' }, 'ABS-资产证券化')
      this.dialogVisible = true
    },
    async getTagFromJd() {
      if (this.project.岗位要求 || this.project.岗位职责 || this.project.核心要求汇总) {
        const option = {}
        if (this.project.职能模块) option.cate = [this.project.职能模块]
        option.jdString = `岗位职责：\n${this.project.岗位职责 || ''}\n岗位要求：\n${this.project.岗位要求 ||
          ''}\n${this.project.核心要求汇总 || ''}`

        const res = await app.service('project').getTagFromJd(option)
        if (res.status === 'success') {
          const arr = res.data || []
          this.addTagFromJd(arr)
        } else this.$message.error(res.msg)
      }
    },
    addTagFromJd(arr = []) {
      if (arr.length === 0) return
      const { singleTag, tags, tagsLabelTranslate } = this
      for (const item of arr) {
        const label = tagsLabelTranslate[item.标签] || item.标签
        const tag = item.标签内容
        if (tags[label]) {
          if (!this.project.标签) this.$set(this.project, '标签', [])
          if (!this.project.标签.includes(tag)) this.project.标签.push(tag)
        } else if (singleTag.includes(label)) {
          if (!this.project[label]) this.$set(this.project, label, tag)
        } else {
          if (!this.project[label]) this.$set(this.project, label, [])
          if (!this.project[label].includes(tag)) this.project[label].push(tag)
        }
      }
      this.$message.success('解析JD添加标签成功')
    },
    async getCompanyRadishImage(company) {
      const option = { cid: company._id }
      const res = await app.service('company').getCompanyStatistics(option)
      if (res.status === 'success') {
        this.hasRadishImage = true
        this.radishImage = (res.data && res.data[0]) || {}
      }
    },
    async getCompanyRadishImageCate(company, cate) {
      const option = { cid: company._id, cate: cate }
      const res = await app.service('company').getCompanyStatistics(option)
      if (res.status === 'success') {
        this.hasRadishCateImage = true
        this.radishImageCate = (res.data && res.data[0]) || {}
      }
    },
    radishImageTemplate(radishImage, item) {
      const val = radishImage[item]
      if (!val) return ''
      if (val['统计'] && val['统计'][0] && val['统计'][0][0] === '未知' && val['统计'][1]) {
        return `${val['统计'][1][0]}（${(val['统计'][1][2] * 100).toFixed(1)}%）`
      }
      return ''
    },
    confirm() {
      this.$refs.TagClassifyDialog.open(this.project)
    },
    tagClassifyConfirm(params) {
      const res = Object.assign({}, this.project, { 标签分类: params })
      this.$emit('confirm', res)
      this.dialogVisible = false
    },
    addQuestion() {
      if (!this.project.核心要求) this.$set(this.project, '核心要求', [])
      this.project.核心要求.push('')
    },
    removeQuestion(index) {
      this.project.核心要求.splice(index, 1)
    },
  },
}
</script>
<style>
.job-requirement-dialog .el-dialog__body {
  padding-top: 0px;
}
.requirement-content-item .el-input-group__append {
  padding-left: 5px;
  padding-right: 5px;
}
</style>
<style scoped>
.job-requirement-content {
  display: flex;
}
.left-box {
  flex: auto;
  padding-right: 20px;
}
.right-box {
  width: 400px;
  flex: none;
  border: 1px solid #9d9d9d;
  border-radius: 5px;
  background: #eee;
  padding: 10px 20px;
}
.radish-pic-analyze-title {
  font-size: 18px;
  font-weight: 700;
}
.requirement-title {
  font-size: 18px;
  color: #9b9b9b;
}
.requirement-content-box {
  display: flex;
  flex-wrap: wrap;
}
.requirement-content-item {
  width: 270px;
  padding: 5px;
  display: flex;
}
.requirement-content-item-checkbox {
  width: 510px;
}
.requirement-content-item .requirement-label {
  width: 70px;
  padding: 0 5px;
  flex: none;
  align-items: baseline;
  display: flex;
}
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}
.radish-content {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.radish-content-item {
  padding: 5px;
  width: 50%;
  display: flex;
}
.requirement-content-item .el-select {
  align-self: baseline;
}
.dialog-title {
  font-size: 16px;
  text-align: left;
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 8px;
}
.quick-btn {
  border: 1px solid #5aa2ea;
  color: #5aa2ea;
  padding: 3px 10px;
  display: inline-block;
  border-radius: 5px;
  min-width: 95px;
  text-align: center;
  margin-bottom: 10px;
  margin-right: 15px;
  cursor: pointer;
  font-size: 14px;
}
</style>
